import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Phase 7 — Session-scoped TEST banner. Reads /test_session/status via the
// axios client (which sends withCredentials so the signed cookie is included).
// Never shown to a normal client browser. Poll lightly so start/stop from the
// admin dashboard become visible without a full page reload.
export default function TestModeBanner() {
    const [active, setActive] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const check = async () => {
            try {
                const { data } = await api.get("/test_session/status");
                if (!cancelled) setActive(!!data?.active);
            } catch { /* fail closed → hide banner */ }
        };
        check();
        const t = setInterval(check, 15000);
        // Phase 7 UX — refresh instantly when admin toggles start/stop from AdminDashboard.
        const onChanged = () => check();
        window.addEventListener("pm:test-session-changed", onChanged);
        return () => { cancelled = true; clearInterval(t); window.removeEventListener("pm:test-session-changed", onChanged); };
    }, []);

    if (!active) return null;
    return (
        <div className="w-full bg-amber-500 text-white text-sm font-medium text-center py-2 px-4 sticky top-0 z-40 shadow-md" data-testid="test-mode-banner">
            <span className="uppercase tracking-widest text-xs mr-2">MODE TEST</span>
            — Aucun e-mail réel ne sera envoyé
        </div>
    );
}
